import { Component, Inject, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { EmpDetails } from "@aptsi-types";
import { IdentityProvisioningService } from "../identity-provisioning.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { tryCatch } from "rxjs/internal-compatibility";
import { ImportFailDialogComponent } from "../../shared/dialogs/import-fail-dialog.component";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";
import { ImportDialogComponent } from "../../shared/dialogs/import-dialog/import-dialog.component";
import { EnvironmentService } from "src/app/core/service/environment.service";

@Component({
  selector: "app-import-emp-info",
  templateUrl: "./import-emp-info.component.html",
  styleUrls: ["./import-emp-info.component.scss"],
})
export class ImportEmpInfoComponent implements OnInit {
  form: FormGroup;
  empDetails: EmpDetails[] = [];
  verify: string;
  readonly organizationOptions = [
    {key: "Acme corp 1  ( Source System: Microsoft Entra Id )", value: "Acme corp 1"},
    {key: "Acme corp 2  ( Source System: LDAP ) ", value: "Acme corp 2"},
    {key: "Acme corp 3  ( Source System: PostgreSQL ) ", value: "Acme corp 3"},
    {key: "None", value: "None"},
  
  ];
  readonly organizationUnitOptions = [
    "Sales",
    "Marketing",
    "Engineering",
    "None",
  ];

  constructor(
    private router: Router,
    private identityProvisioningService: IdentityProvisioningService,
    private dialog: MatDialog,
    public environmentService: EnvironmentService 
  ) { }

  async ngOnInit(): Promise<void> {
    this.form = new FormGroup({
      organization: new FormControl("None", [
        Validators.required,
        this.typeValidator,
      ]),
      organizationUnit: new FormControl("None"),
    });
  }

  typeValidator(control: AbstractControl): { [key: string]: any } | null {
    const selectedType = control.value;
    if (selectedType === "None") {
      return { noneSelected: true };
    }
    return null;
  }

  back() {
    this.router.navigate(["digital-identity/auth-tools/identity-provisioning"]);
  }

  async import() {
    const response = await this.identityProvisioningService
      .importEmpDetail(
        this.form.value.organization,
        this.form.value.organizationUnit
      )
      .toPromise();

    this.verify = response;
    if (this.verify === "New records found") {
      console.log("no success");
      const dialogRef = this.dialog.open(ImportDialogComponent, {
        data: {
          title: "New Record Added Success",
          subTitle: "Duplicate records found.",
          
          // path: "digital-identity/auth-tools/identity-provisioning/import-emp-info",
          // pathoverride:
          //   "digital-identity/auth-tools/identity-provisioning/aggregate-emp-details",
          // orgnization: `${this.form.value.organization}`,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.router.navigate([
          "digital-identity/auth-tools/identity-provisioning/aggregate-emp-details",this.form.value.organization,this.form.value.organizationUnit
        ]);
      });
    }
    else if (this.verify === "Duplicate") {
      console.log("no success");
      this.dialog.open(ImportDialogComponent, {
        data: {
          title: "Record Already Exists",
          subTitle: "Duplicate records found.",
          
          // path: "digital-identity/auth-tools/identity-provisioning/import-emp-info",
          // pathoverride:
          //   "digital-identity/auth-tools/identity-provisioning/aggregate-emp-details",
          // orgnization: `${this.form.value.organization}`,
        },
      });
    } else if (this.verify === "Updated records found") {
      this.dialog.open(ImportDialogComponent, {
        data: {
          title: "Updated Records Found",
          subTitle: "existing records were updated.",

        },
      });
    } else if (this.verify === "Records deleted") {
      this.dialog.open(ImportDialogComponent, {
        data: {
          title: "Deleted Records Found ",
          subTitle: "some records were deleted.",

        },
      });
    } else if (this.verify === "New, updated, and deleted records found") {
      this.dialog.open(ImportDialogComponent, {
        data: {
          title: " Records has been changed",
          subTitle: "records were either updated or deleted.",

        },
      });
    } else {
      console.log("success");
      this.openSuccessDialog();
    }
  }

  openSuccessDialog(): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: {
        isMessage: true,
        isCreateUpdate: false,
        title: "Asset Details Imported Successfully",
        subTitle:
          "Asset details have been successfully imported. All data has been integrated and is now available for review.",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate([
        "digital-identity/auth-tools/identity-provisioning/aggregate-emp-details",this.form.value.organization,this.form.value.organizationUnit
      ]);
    });
  }
}
